import './App.css';
import { Calculadora } from './components/calculadora/index';

function App() {
  return (
    <div className="App">
      <Calculadora />
    </div>
  );
}

export default App;

